const config = {
  colonias: {
    id: "id_colonia",
    columnas: [
      { campo: "nombre_colonia", label: "Colonia", tipo: "text" },
      { campo: "codigo_postal", label: "CP", tipo: "text" },
      { campo: "activo", label: "Activo", tipo: "checkbox" }
    ]
  },

  servicios: {
    id: "id_servicio",
    columnas: [
      { campo: "nombre", label: "Nombre", tipo: "text" },
      { campo: "fecha", label: "Fecha", tipo: "date" },
      { campo: "hora", label: "Hora", tipo: "time" }
    ]
  },

  municipios: {
    id: "id_municipio",
    columnas: [
      { campo: "nombre_municipio", label: "Municipio", tipo: "text" },
      { campo: "activo", label: "Activo", tipo: "checkbox" }
    ]
  },

  estados: {
    id: "id_estado",
    columnas: [
      { campo: "nombre_estado", label: "Estado", tipo: "text" }
    ]
  },
  miembros_club: {
  id: "id_miembro_club",
  placeholderBusqueda: "Buscar por miembro, club o tipo...",
  columnas: [
    {
      campo: "id_miembro",
      label: "Miembro",
      tipo: "select",
      ref: "miembros",
      refId: "id_miembro",
      refLabel: ["nombre", "paterno", "materno"]
    },
    {
      campo: "id_club",
      label: "Club",
      tipo: "select",
      ref: "clubs",
      refId: "id_club",
      refLabel: ["nombre_club"]
    },
    {
      campo: "tipo",
      label: "Tipo",
      tipo: "select",
      opciones: [
        { value: 1, label: "Encargado" },
        { value: 2, label: "Colaborador" }
      ]
    },
    {
      campo: "activo",
      label: "Activo",
      tipo: "checkbox"
    }
  ]
},

  clubs: {
    id: "id_club",
    columnas: [
      { campo: "nombre_club", label: "Club", tipo: "text" },
      { campo: "ubicacion", label: "Ubicación", tipo: "text" }
    ]
  },

  lista_aseo: {
    id: "id_aseo",
    columnas: [
      { campo: "numero", label: "No.", tipo: "number", editable: false },
      { campo: "familia", label: "Familia", tipo: "text" },
      { campo: "hermano", label: "Hermano", tipo: "text" },
      { campo: "activo", label: "Activo", tipo: "checkbox" }
    ]
  },

  directores_musica: {
    id: "id_director",
    columnas: [
      {
        campo: "id_miembro",
        label: "Director",
        tipo: "select",
        ref: "miembros",
        refId: "id_miembro",
        refLabel: ["nombre", "paterno", "materno"],
        opcionesEndpoint: "/api/miembros/disponibles-director"
      },
      { campo: "activo", label: "Activo", tipo: "checkbox" }
    ]
  },

  proyeccion: {
    id: "id_proyeccion",
    columnas: [
      {
        campo: "id_miembro",
        label: "Miembro",
        tipo: "select",
        ref: "miembros",
        refId: "id_miembro",
        refLabel: ["nombre", "paterno", "materno"],
        opcionesEndpoint: "/api/miembros/disponibles-proyeccion"
      },
      { campo: "activo", label: "Activo", tipo: "checkbox" }
    ]
  },

  lecciones_clase: {
    id: "id_leccion",
    columnas: [
      { campo: "fecha", label: "Fecha", tipo: "date", editable: false },
      {
        campo: "id_servicio",
        label: "Servicio",
        tipo: "select",
        ref: "servicios",
        refId: "id_servicio",
        refLabel: "fecha",
        opcionesEndpoint: "/api/dominical/servicios-clases",
        mostrarEnTabla: false
      },
      { campo: "ninos", label: "Niños", tipo: "text" },
      { campo: "segundo_tiempo", label: "Segundo Tiempo", tipo: "text" },
      { campo: "adultos", label: "Adultos", tipo: "text" },
      { campo: "activo", label: "Activo", tipo: "checkbox" }
    ]
  },

  tipos_reunion: {
    id: "id_tipo",
    placeholderBusqueda: "Buscar tipo de reunión...",
    columnas: [
      { campo: "nombre", label: "Tipo de reunión", tipo: "text" },
      {
        campo: "accion_miembro",
        label: "Registra en Miembros",
        tipo: "select",
        valorInicial: "ninguna",
        opciones: [
          { value: "ninguna", label: "Nada (no lleva persona)" },
          { value: "bautismo", label: "Fecha de bautismo" },
          { value: "ingreso", label: "Fecha de ingreso" }
        ]
      },
      { campo: "activo", label: "Activo", tipo: "checkbox" }
    ]
  },

  categorias_salida: {
    id: "id_categoria",
    placeholderBusqueda: "Buscar categoría...",
    columnas: [
      { campo: "nombre", label: "Categoría", tipo: "text" },
      { campo: "activo", label: "Activo", tipo: "checkbox" }
    ]
  }
};

export default config;